import React from 'react';
import { Image } from 'semantic-ui-react';
import logo from '../images/logo-transparent.png';

export const Logo = () => (
  <div>
    <Image src={logo} size="tiny" />
  </div>
);
